import { useEffect } from 'react'

interface SrcProps {
  scriptSrc: string
  scriptContent?: never
}

interface ContentProps {
  scriptSrc?: never
  scriptContent: string
}

type Props = SrcProps | ContentProps

export const useScript = (props: Props) => {
  const { scriptContent, scriptSrc } = props
  useEffect(() => {
    const script = document.createElement('script')
    if (scriptSrc) {
      script.src = scriptSrc
    }
    if (scriptContent) {
      script.innerHTML = scriptContent
    }
    script.async = true

    document.body.append(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [scriptContent, scriptSrc])
}
